import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    countryList: any;
    // stateList: State[];
    // cityList: City[];
    // localityList: Locality[];

    constructor(
        private http: HttpClient
    ) { }

    /*********** Country **********/
    getCountry(): Observable<any> {
        if (!this.countryList) {
            this.countryList = this.http.get<any>(`${environment.endPoint}/Location/Countries`)
                .pipe(map(resp => {
                    return resp.data;
                }),
                    publishReplay(1),
                    refCount()
                );
        }
        return this.countryList
    }

    /*********** State **********/
    getState(CountryId): Observable<any> {
        console.log(CountryId)
        return this.http.get<any>(`${environment.endPoint}/Location/States/` + CountryId)
            .pipe(map(resp => {
                console.log(resp.data);
                return resp.data;

            }));
    }
   

    /*********** City **********/
    getCity(StateId): Observable<any> {
        return this.http.get<any>(`${environment.endPoint}/Location/Cities/` + StateId)
            .pipe(map(resp => {
                return resp.data;
            }));
    }

    /*********** Locality **********/
    getLocality(CityId): Observable<any> {
        return this.http.get<any>(`${environment.endPoint}/Location/Localities/` + CityId)
            .pipe(map(resp => {
                return resp.data;
            }));
    }

    /*********** Members **********/
    myTeam(): Observable<any> {
        const params =
        {
            'from': 1,
            'to': -1,
            'text': ''
        };
        return this.http.post(`${environment.endPoint}/CRM/MyTeam`, params)
            .pipe(map(res => res));
    }
}
